import { createSelector } from 'reselect';
import { getDevicesState } from './devices-state';
import { getCameraOptions, getSpeakerOptions, getMicrophoneOptions, } from './devices';
const getDeviceByIdResultFunc = (devices, id) => devices[id];
export const getCurrentDevicesInfo = (state) => getDevicesState(state).current;
export const getCurrentSpeakerId = (state) => getCurrentDevicesInfo(state).speakerId;
export const getCurrentMicrophoneId = (state) => getCurrentDevicesInfo(state).microphoneId;
export const getCurrentCameraId = (state) => getCurrentDevicesInfo(state).cameraId;
export const getFacingMode = (state) => getCurrentDevicesInfo(state).facingMode;
export const getCurrentCamera = createSelector(getCameraOptions, getCurrentCameraId, getDeviceByIdResultFunc);
export const getCurrentSpeaker = createSelector(getSpeakerOptions, getCurrentSpeakerId, getDeviceByIdResultFunc);
export const getCurrentMicrophone = createSelector(getMicrophoneOptions, getCurrentMicrophoneId, getDeviceByIdResultFunc);
